import { z } from 'zod';
export const SummarizerParameterSchema = z.enum(['SUMMARIZER_BASE_URL']);
export const SummarizerParameterEnum = SummarizerParameterSchema.enum;
